/* ltt-cart-cap — refuses checkout while the Buy-3-Get-1 same-product cap is
   broken.

   It renders nothing and owns no copy. The message is Liquid, in
   snippets/ltt-offer-cap.liquid, from the theme locale files. That is
   deliberate: ltt-options.js once shipped an Arabic fallback string in the JS
   itself and the English store answered its shoppers in Arabic.

   WHY A SCRIPT IS NEEDED AT ALL, when the notice itself is zero-JS:
   the checkout button is outside every region the cart repaints, on BOTH
   surfaces —
     • drawer: the button is in .cart__ctas, a sibling of .cart-drawer__footer,
       so CartItems.onCartUpdate() never touches it.
     • cart page: #checkout is the `buttons` block, while
       CartItems.getSectionsToRender() names main-cart-footer's `.js-contents`,
       which is the `subtotal` block only.
   A Liquid `disabled` attribute would therefore be correct on first paint and
   wrong after the first quantity change.

   Delegated at document level, capture phase — the same reasoning as
   ltt-cart-promo.js (the drawer's markup is replaced wholesale on every cart
   change, so per-element binding is lost) and ltt-options.js (capture runs
   before Dawn's own handlers, so the fetch never leaves). */
(function () {
  'use strict';
  if (window.lttCartCapBound) return;
  window.lttCartCapBound = true;

  var FLAG = '[data-ltt-cap-blocked]';
  /* The two forms that post to checkout. The promo-code box is its own <form>
     and is not in this list, so entering a discount still works while blocked. */
  var FORMS = { cart: 1, 'CartDrawer-Form': 1 };

  function blocker() {
    return document.querySelector(FLAG);
  }

  /* Read by ltt-buy-now.js, which leaves for /checkout without ever passing
     through a cart surface. */
  window.lttCartCapBlocked = function () {
    return !!blocker();
  };

  function refuse(event, notice) {
    event.preventDefault();
    event.stopImmediatePropagation();
    notice.setAttribute('tabindex', '-1');
    notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
    notice.focus({ preventScroll: true });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var trigger = target.closest('[name="checkout"]');
      if (!trigger) return;
      var notice = blocker();
      if (notice) refuse(event, notice);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      if (!FORMS[event.target.id]) return;
      /* `submitter` is undefined on older Safari. Falling through and blocking
         is the safe direction: over-blocking shows a message the shopper can
         act on, under-blocking hands out a free unit. */
      if (event.submitter && event.submitter.name !== 'checkout') return;
      var notice = blocker();
      if (notice) refuse(event, notice);
    },
    true
  );
})();
